import {createApp} from "vue";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import ShopWindowApp from "./ShopwindowApp.vue";
import ArticleDetailApp from "./ArticleDetailApp.vue";
import ArticleSetDetailApp from "./ArticleSetDetailApp.vue";
import ServiceDetailApp from "./ServiceDetailApp.vue";
import CartApp from "./CartApp.vue";

import api from "./api";

import {createPinia} from "pinia";

// App Wide Components
import AppCountInput from "./components/AppCountInput.vue";
import AppAddToCart from "./components/AppAddToCart.vue";
// Translation
import { i18n } from './i18n/i18n.js';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
export const TAX_RATE = 8.1;

// Init App
api.init();

if (document.getElementById("shopwindow")) {
    createApp(ShopWindowApp)
        // .use(bugsnagVue)
        .use(i18n)
        .use(pinia)
        .component("AppCountInput", AppCountInput)
        .component("AppAddToCart", AppAddToCart)
        .mount("#shopwindow");
}

if (document.getElementById("articleDetail")) {
    createApp(ArticleDetailApp)
        .use(i18n)
        .use(pinia)
        .component("AppAddToCart", AppAddToCart)
        .mount("#articleDetail");
}

if (document.getElementById("articleSetDetail")) {
    createApp(ArticleSetDetailApp)
        .use(i18n)
        .use(pinia)
        .component("AppAddToCart", AppAddToCart)
        .mount("#articleSetDetail");
}

if (document.getElementById("serviceDetail")) {
    createApp(ServiceDetailApp)
        .use(i18n)
        .use(pinia)
        .component("AppAddToCart", AppAddToCart)
        .mount("#serviceDetail");
}

// Init Basket
if (document.getElementById("cart")) {
    createApp(CartApp)
        // .use(bugsnagVue)
        .use(i18n)
        .use(pinia)
        .component("AppCountInput", AppCountInput)
        .mount("#cart");
}
